import { render } from "./App_Downloads.vue?vue&type=template&id=aee89e9e"
import script from "./App_Downloads.vue?vue&type=script&lang=js"
export * from "./App_Downloads.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__